import { CacheLookupPolicy, LogLevel } from '@azure/msal-browser';
import { KEYS } from '../Constants/Constants';

/**
 * @module AuthConfig
 * @description Configuration object for Azure AD authentication using MSAL.
 *
 * @typedef {Object} AuthConfig
 * @property {Object} msalConfig - MSAL library configuration options.
 *   @property {Object} msalConfig.auth - Authentication configuration.
 *     @property {string} msalConfig.auth.clientId - Client ID for your Azure AD application (from environment variables).
 *     @property {string} msalConfig.auth.authority - Azure AD authority URL (from environment variables).
 *     @property {string} msalConfig.auth.redirectUri - Redirect URI for authentication flow (from environment variables).
 *     @property {boolean} msalConfig.auth.navigateToLoginRequestUrl - Whether to redirect to the login request URL.
 *   @property {Object} msalConfig.cache - Cache configuration.
 *     @property {string} msalConfig.cache.cacheLocation - Location to store the token cache (default: "localStorage").
 *     @property {boolean} msalConfig.cache.storeAuthStateInCookie - Whether to store authentication state in a cookie (default: false).
 *   @property {Object} msalConfig.system - System configuration.
 *     @property {Object} msalConfig.system.loggerOptions - Logging configuration.
 *       @property {function} msalConfig.system.loggerOptions.loggerCallback - Callback function for logging messages.
 * @property {Object} loginRequest - Login request configuration for MSAL.
 *   @property {string[]} loginRequest.scopes - Scopes requested during login (default: ["offline_access"]).
 *   @property {CacheLookupPolicy} loginRequest.cacheLookupPolicy - Cache lookup policy for token acquisition (default: CacheLookupPolicy.AccessTokenAndRefreshToken).
 *   // @property {boolean} loginRequest.forceRefresh - Whether to force token refresh (default: false).
 *   // @property {number} loginRequest.refreshTokenExpirationOffsetSeconds - Offset for refresh token expiration (default: 4 hours).
 */
export const AuthConfig = {
  msalConfig: {
    auth: {
      clientId: KEYS?.AZURE_B2B_CLIENT_ID,
      authority: `https://login.microsoftonline.com/${KEYS?.AZURE_B2B_TENANT_ID}`,
      redirectUri: KEYS?.AZURE_REDIRECT_URL,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'localStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
          if (containsPii) {
            return;
          }
          // switch (level) {
          //   case LogLevel.Error:
          //     console.error(message);
          //     return;
          //   case LogLevel.Info:
          //     console.info(message);
          //     return;
          //   case LogLevel.Verbose:
          //     console.debug(message);
          //     return;
          //   case LogLevel.Warning:
          //     console.warn(message);
          //     return;
          //   default:
          //     return;
          // }
        },
      },
    },
  },
  loginRequest: {
    scopes: ['offline_access'],
    cacheLookupPolicy: CacheLookupPolicy.AccessTokenAndRefreshToken,
    // forceRefresh: true,
    // refreshTokenExpirationOffsetSeconds: 4 * 60 * 60,
  },
};
